import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AlertService, AlertType } from 'src/app/core/services/alert.service';
import { MemberService } from 'src/app/core/services/member.service';
import { UserService } from 'src/app/core/services/user.service';
import { AppButtonComponent } from 'src/app/shared/components/app-button/app-button.component';
import { UserModel } from 'src/app/shared/models/userModel';

@Component({
  selector: 'app-send-confirmation-email',
  standalone: true,
  imports: [AppButtonComponent],
  templateUrl: './send-confirmation-email.component.html',
  styleUrl: './send-confirmation-email.component.scss'
})
export class SendConfirmationEmailComponent implements OnInit {

  pageTitle = 'Reenviar Confirmação de Email';
  submitCount: number = 0;
  dataMember: any;

  logoUrl: string = localStorage.getItem('imageLogo') || '';

  buttonOptions = {
    buttonText: 'Voltar',
    buttonBorderWidth: '1px',
    buttonSize: 'btn btn-md px-3 btn-secondary',
    borderRadius: '25px'
  };

  buttonOptionsSendEmail = {
    buttonText: 'Enviar Link',
    buttonBorderWidth: '1px',
    buttonSize: 'btn btn-md px-3 btn-secondary',
    borderRadius: '25px'
  };

  constructor(
    private location: Location,
    private memberService: MemberService,
    private alertService: AlertService,
    private userService: UserService,
    private router: Router
  ) { }

  ngOnInit(): void {
    const user = this.userService.currentUserValue as UserModel;
    const cpf = history.state.cpf || user?.cpf;

    if (!cpf) {
      this.alertService.showAlert(
        AlertType.WARNING,
        'Login não realizado. Tente novamente.'
      );
      this.router.navigate(['/login']);
    }

    this.memberService.getDataUserByCpf(cpf).subscribe(res => {
      this.dataMember = res;
    });
  }

  back() {
    this.location.back();
  }

  resendEmail() {
    this.memberService.resendEmail(this.dataMember).subscribe({
      next: () => {
        this.alertService.showAlert(
          AlertType.SUCCESS,
          "O e-mail com o link de validação foi enviado para o seu e-mail. Favor, verificar."
        );

        this.blockSubmit();
      },
      error: error => {
        console.error('Erro ao reenviar email de confirmação:', error);
        this.alertService.showAlert(
          AlertType.DANGER,
          error?.error?.message || 'Erro ao reenviar email de confirmação. Tente novamente.'
        );

        this.blockSubmit();
      }
    });
  }

  blockSubmit() {
    this.submitCount = 30;
    if (this.submitCount > 0) {
      const interval = setInterval(() => {
        this.submitCount--;
        if (this.submitCount === 0) {
          clearInterval(interval);
        }
      }, 1000);
    }
  }

}
